<template>
  <div id="app">
    <div id="nav" class="tab-area-base">
      <ul class="tab-menu-base">
        <li>
          <router-link to="/">
            Home
          </router-link>
        </li>
      </ul>
    </div>
    <router-view />
  </div>
</template>

<script>
import liff from '@line/liff'
import db from './firestore.js'
export default {
  data() {
    return {
      loggedIn: false,
      idToken: {},
    }
  },
  mounted() {
    // 最初に必ず実行する
    liff
      .init({ liffId: '1656076740-9mBDWvzg' })
      .then(() => {
        if (!liff.isLoggedIn()) {
          liff.login()
        }
        this.loggedIn = liff.isLoggedIn();
        this.idToken = liff.getDecodedIDToken();
        // 初期化が完了したこの時点でユーザデータはLocalstorageに保存されている(key='LIFF_STORE:1656076740-9mBDWvzg:decodedIDToken')

        // ユーザデータを取得/保存
        // LocalStorageから取得したJson文字列をパース
        // const userObj = JSON.parse(localStorage.getItem('LIFF_STORE:1656076740-9mBDWvzg:decodedIDToken'))
        // firestoreからユーザのデータを取得してstoreとLocalstrageに保存
        // db.collection('users').doc(userObj.sub).get().then((doc) => {
          db.collection('users').doc(this.idToken.sub).get().then((doc) => {
          if(doc.exists) {
            this.$store.commit('userInfo', doc.data()) 
          // firestoreにユーザデータがなければ追加 
          } else {
            db.collection('users').doc(this.idToken.sub).set({ 
            userId: this.idToken.sub,
            userName: this.idToken.name,
            userPic: this.idToken.picture,
            })
          }  
        })

        // listデータを取得/保存
        // 最初はfirestoreから取ってくる
        db.collection('users')
          .get()
          .then((snap) => {
            const usrArr = []
            snap.forEach((doc) => {
              usrArr.push(doc.data())
            })
            // storeとLocalStorageに保存  
            this.$store.commit('usersInfo', usrArr)  
          })
      })
      .catch((err) => {
        // Error happens during initialization
        this.occoredError = 'error:' + err
      })
  }
  
}
</script>
